import React from "react";
import PropTypes from "prop-types";

const SkipNextBackward = ({ fillColor }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="10" height="9.935" viewBox="0 0 10 9.935">
			<path
				id="skip-next-back"
				d="M26,15.935H24.344V6H26m-2.963,9.935L16,10.967,23.037,6Z"
				transform="translate(-16 -6)"
				fill={fillColor}
			/>
		</svg>
	);
};

SkipNextBackward.propTypes = {
	fillColor: PropTypes.string.isRequired
};

SkipNextBackward.defaultProps = {
	fillColor: "#000000"
};

export default SkipNextBackward;
